// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AdminLogin_wrapper__2z_bA","title":"AdminLogin_title__mT9iO","form":"AdminLogin_form__1Sn1F","field":"AdminLogin_field__3aBD4"};